import { render, staticRenderFns } from "./comp_DescriptionExpandable.vue?vue&type=template&id=028f1b83&scoped=true"
import script from "./comp_DescriptionExpandable.vue?vue&type=script&lang=js"
export * from "./comp_DescriptionExpandable.vue?vue&type=script&lang=js"
import style0 from "./comp_DescriptionExpandable.vue?vue&type=style&index=0&id=028f1b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f1b83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
